export const libTypeOptions = [
    {
        label: "设计资料",
        // Design Data
        value: "DD",
    },
    {
        label: "作业指导书",
        // Working Instruction
        value: "WI",
    },
    {
        label: "装配记录表",
        // Assembly Record
        value: "AR",
    },
    {
        label: "检验规程",
        // InspectionProcedures
        value: "IP",
    }, {
        label: "检验记录表",
        // inspectionRecord
        value: "IR",
    },
    {
        label: "工位清单",
        // stationList
        value: "SL",
    },
];

export const bomOptions = [
    {
        label: "总BOM",
        value: "allbom",
        type: null,
        authorityKey: 'isAll',
    },
    {
        label: "光学BOM",
        value: "opticsbom",
        type: 'M04',
        authorityKey: 'isOptics',
    },
    {
        label: "结构BOM",
        value: "structurebom",
        type: 'M02',
        authorityKey: 'isStructure',
    },
    {
        label: "电子BOM",
        value: "electronbom",
        type: 'M01',
        authorityKey: 'isElectron',
    },
    // {
    //     label: "辅料BOM",
    //     value: "accessoriesbom",
    //     type: 'M08',
    //     authorityKey: 'isAccessories',
    // },
]

export const structureOptions = [
    {
        label: "嵌入式软件部",
        value: "嵌入式软件部",
    },
    {
        label: "结构部",
        value: "结构部",
    },
    {
        label: "算法部",
        value: "算法部",
    },
    {
        label: "光学部",
        value: "光学部",
    },
    {
        label: "云端软件部",
        value: "云端软件部",
    },
    {
        label: "电子部",
        value: "电子部",
    },
    {
        label: "产品设计部",
        value: "产品设计部",
    },
    {
        label: "工程部",
        value: "工程部",
    },
];

export const projectLifeCycleOptions = [
    {
        label: "M0 概念阶段",
        value: "M0 概念阶段",
    },
    {
        label: "M1 计划阶段",
        value: "M1 计划阶段",
    },
    {
        label: "M2 开发阶段",
        value: "M2 开发阶段",
    },
    {
        label: "M3 验证阶段",
        value: "M3 验证阶段",
    },
    {
        label: "M4 量产阶段",
        value: "M4 量产阶段",
    },
    {
        label: "M5 生命周期阶段",
        value: "M5 生命周期阶段",
    },
];

export const fileTypeOptions = [
    {
        label: "结构BOM",
        value: "结构BOM",
    },
    {
        label: "设计原理图",
        value: "设计原理图",
    },
    {
        label: "图纸",
        value: "图纸",
    },
    {
        label: "加工文件",
        value: "加工文件",
    },
    {
        label: "其他",
        value: "其他",
    },
]

export const tableColunms = [
    {
        label: "文件类型",
        dataName: "fileType",
    },
    {
        label: "文件名称",
        dataName: "fileName",
    },
    {
        label: "版本",
        dataName: "version",
    },
    {
        label: "文件",
        dataName: "fileLink",
    },
    {
        label: "推送",
        dataName: "push",
    },
    {
        label: "工作记录",
        dataName: "workRecords",
    },
    {
        label: "设计人",
        dataName: "username",
    },
    {
        label: "上传时间",
        dataName: "uploadTime",
    },
    {
        label: "产线资料",
        dataName: "isProductionData",
    },
    {
        label: "体系资料",
        dataName: "isSystemData",
    },
    {
        label: "操作",
        dataName: "action",
    },
]
